import { Color } from "cesium";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
const PLANE_COLOR = Color.fromCssColorString("#FFD54F").withAlpha(0.35);
/**
 * 面選択の水平基準面モードで表示する 1 枚の水平面。
 * 選択が変わるごとに `set` で作り直し、選択モード終了時に `dispose` する。
 * トレース対象外・見た目だけ。
 */
export class HorizontalBasePlane {
    _viewer;
    _primitive = null;
    constructor(viewer) {
        this._viewer = viewer;
    }
    /** 既存の Primitive を破棄してから作り直す (Primitive Dispose Lifecycle) */
    set(wgs84Geometry) {
        this.dispose();
        const primitive = EarthBrainUtils.createEntityFromIndexedGeometry({
            vertices: [...wgs84Geometry.vertices],
            indices: [...wgs84Geometry.indices],
        }, PLANE_COLOR);
        if (!primitive)
            return;
        this._primitive = primitive;
        this._viewer.scene.primitives.add(primitive);
    }
    dispose() {
        if (this._primitive && !this._primitive.isDestroyed()) {
            this._viewer.scene.primitives.remove(this._primitive);
        }
        this._primitive = null;
    }
}
//# sourceMappingURL=horizontal-base-plane.js.map